<template>
  <div class="map-columns-container">
    <Typography variant="h-5">
      <strong>
        Match each column in your file to the right field so your data imports correctly
      </strong>
    </Typography>
    <MapCSVColumnsTable
      :rows="rows"
      :columns="columns"
      @mapped-csv-columns-updated="onMappedRowsChange"
      showDeleteRowButton
      showRowCount
      showRequiredColumns
      @delete-row="$emit('delete-row', $event)"
    />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography";
import MapCSVColumnsTable from "@/components/MapCSVColumnsTable.vue";

export default {
  name: "MapColumns",
  components: {
    Typography,
    MapCSVColumnsTable,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onMappedRowsChange(mappedRows) {
      this.$emit("change", mappedRows);
    },
  },
};
</script>

<style scoped>
.map-columns-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  justify-content: flex-start;
  width: 100%;
  gap: 0.5rem;
  margin-top: 1.5rem;
}
</style>
